/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScaleReading } from './ScaleReading';
import {
    ScaleReadingFromJSON,
    ScaleReadingFromJSONTyped,
    ScaleReadingToJSON,
    ScaleReadingToJSONTyped,
} from './ScaleReading';
import type { Calibration } from './Calibration';
import {
    CalibrationFromJSON,
    CalibrationFromJSONTyped,
    CalibrationToJSON,
    CalibrationToJSONTyped,
} from './Calibration';

/**
 * 
 * @export
 * @interface WeightDebug
 */
export interface WeightDebug {
    [key: string]: any | any;
    /**
     * 
     */
    scaleReadings: Array<ScaleReading>;
    /**
     * 
     */
    observedCellFractions?: { [key: string]: number; } | null;
    /**
     * 
     */
    calibration?: Calibration | null;
    /**
     * 
     */
    rawWeightGrams?: number | null;
    /**
     * 
     */
    redistributionFactor?: number | null;
    /**
     * 
     */
    weightStable?: boolean | null;
    /**
     * 
     */
    weightStableWindowStartTs?: number | null;
    /**
     * 
     */
    weightStableWindowEndTs?: number | null;
    /**
     * 
     */
    weightStableWindowStddevGrams?: number | null;
}

/**
 * Check if a given object implements the WeightDebug interface.
 */
export function instanceOfWeightDebug(value: object): value is WeightDebug {
    if ((!('scaleReadings' in (value as Record<string, any>)) && !('scale_readings' in (value as Record<string, any>))) || ((value as Record<string, any>)['scaleReadings'] === undefined && (value as Record<string, any>)['scale_readings'] === undefined)) return false;
    return true;
}

export function WeightDebugFromJSON(json: any): WeightDebug {
    return WeightDebugFromJSONTyped(json, false);
}

export function WeightDebugFromJSONTyped(json: any, ignoreDiscriminator: boolean): WeightDebug {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'scaleReadings': ((json['scale_readings'] as Array<any>).map(ScaleReadingFromJSON)),
        'observedCellFractions': json['observed_cell_fractions'] === undefined ? undefined : json['observed_cell_fractions'] === null ? null : json['observed_cell_fractions'],
        'calibration': json['calibration'] === undefined ? undefined : json['calibration'] === null ? null : CalibrationFromJSON(json['calibration']),
        'rawWeightGrams': json['raw_weight_grams'] === undefined ? undefined : json['raw_weight_grams'] === null ? null : json['raw_weight_grams'],
        'redistributionFactor': json['redistribution_factor'] === undefined ? undefined : json['redistribution_factor'] === null ? null : json['redistribution_factor'],
        'weightStable': json['weight_stable'] === undefined ? undefined : json['weight_stable'] === null ? null : json['weight_stable'],
        'weightStableWindowStartTs': json['weight_stable_window_start_ts'] === undefined ? undefined : json['weight_stable_window_start_ts'] === null ? null : json['weight_stable_window_start_ts'],
        'weightStableWindowEndTs': json['weight_stable_window_end_ts'] === undefined ? undefined : json['weight_stable_window_end_ts'] === null ? null : json['weight_stable_window_end_ts'],
        'weightStableWindowStddevGrams': json['weight_stable_window_stddev_grams'] === undefined ? undefined : json['weight_stable_window_stddev_grams'] === null ? null : json['weight_stable_window_stddev_grams'],
    };
}

export function WeightDebugToJSON(json: any): WeightDebug {
    return WeightDebugToJSONTyped(json, false);
}

export function WeightDebugToJSONTyped(value?: WeightDebug | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'scale_readings': ((value['scaleReadings'] as Array<any>).map(ScaleReadingToJSON)),
        'observed_cell_fractions': value['observedCellFractions'],
        'calibration': CalibrationToJSON(value['calibration']),
        'raw_weight_grams': value['rawWeightGrams'],
        'redistribution_factor': value['redistributionFactor'],
        'weight_stable': value['weightStable'],
        'weight_stable_window_start_ts': value['weightStableWindowStartTs'],
        'weight_stable_window_end_ts': value['weightStableWindowEndTs'],
        'weight_stable_window_stddev_grams': value['weightStableWindowStddevGrams'],
    };
}

